import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

const AccountInfo = ({userData, openModal}) => {

     const maskedPassword = "•".repeat(12);

    return (
        <div className='p-4 mt-3 rounded col-10 col-md-8 col-lg-6' style={{border: "1px solid #AEAFBA"}}>
            <h3>Profile</h3>
            <div className='d-flex justify-content-between align-items-center mb-2' style={{cursor: "pointer"}}>
                <div>
                <p className='m-0' style={{fontSize: "15px"}}>Username</p>
                <p className='m-0'>{userData.username}</p>
                </div>
                <FontAwesomeIcon
                icon={faChevronRight}
                style={{ cursor: "pointer", color: "#AEAFBA", cursor: "pointer" }}
                onClick={() => openModal('username')}
                />
            </div>
            <div className='d-flex justify-content-between align-items-center mb-2' style={{cursor: "pointer"}}>
                <div>
                <div className='d-flex align-items-center mb-1'>
                    <p className='m-0' style={{fontSize: "15px"}}>Email</p>
                    <div
                    className="d-block d-md-none ms-2 text-center"
                    style={{
                        borderRadius: "50px", // Elliptical border
                        backgroundColor: userData.email_verified ? "#28a745" : "#dc3545", // Green for verified, red for unverified
                        color: "white", // Text color
                        fontSize: "12px", // Font size
                        fontWeight: "bold", // Bold text
                        minWidth: "80px", // Minimum width for consistent size
                        padding: "2px 8px", // Padding for smaller screens
                    }}
                    >
                    {userData.email_verified ? "Verified" : "Not Verified"}
                    </div>
                </div>
                <div className='d-flex align-items-center'>
                    <p className='m-0 text-truncate'>{userData.email}</p>
                    <div
                    className="d-none d-md-block ms-3 px-2 py-1 text-center"
                    style={{
                        borderRadius: "50px", // Elliptical border
                        backgroundColor: userData.email_verified ? "#28a745" : "#dc3545", // Green for verified, red for unverified
                        color: "white", // Text color
                        fontSize: "12px", // Font size
                        fontWeight: "bold", // Bold text
                        minWidth: "80px", // Minimum width for consistent size
                    }}
                    >
                    {userData.email_verified ? "Verified" : "Not Verified"}
                    </div>
                </div>
                </div>
                <FontAwesomeIcon
                icon={faChevronRight}
                style={{ cursor: "pointer", color: "#AEAFBA", cursor: "pointer" }}
                onClick={() => openModal('editEmail', true)}
                />
            </div>
            <div className='d-flex justify-content-between align-items-center' style={{cursor: "pointer"}}>           
                <div>
                <p className='m-0' style={{fontSize: "15px"}}>Password</p>
                <p className='m-0'>{maskedPassword}</p>
                </div>
                <FontAwesomeIcon
                icon={faChevronRight}
                style={{ cursor: "pointer", color: "#AEAFBA", cursor: "pointer" }}
                onClick={() => openModal('password')}
                />           
            </div>
        </div>
    )
}

export default AccountInfo